import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "app-alert-wrapper"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "backdrop" }, null, -1)
const _hoisted_3 = { class: "content" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "button-wrapper" }

import {computed, ref, watch} from "vue";
import emitter from "@/lib/eventBus";

const useNative = false // window.isCordova()


export default /*#__PURE__*/_defineComponent({
  __name: 'AppAlert',
  props: {
    show: { type: Boolean, default: false },
    title: { default: null },
    message: { default: null },
    buttonLabel: { default: 'OK' },
    showCancel: { type: Boolean, default: false },
    cancelButtonLabel: { default: 'ABBRECHEN' },
    smallFont: { type: Boolean, default: false }
  },
  emits: ["ok", "cancel"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const dialog = ref<HTMLDivElement|null>(null)

const classNames = computed(() => {
  const res: string[] = []
  if (props.smallFont) {
    res.push('small-font')
  }
  return res
})

/*
watch(show, () => {
  if (show.value) {
    if (useNative) {
      navigator.notification.alert(message.value, () => store.dispatch(HIDE_ALERT), title, buttonLabel.value)
    }
  }
})
*/

const show = computed(() => props.show)

watch(show, () => {
  if (show.value) {
    const nodes = dialog.value?.querySelectorAll('[autofocus]')
    if (nodes && nodes[0]) {
      // @ts-ignore
      setTimeout(() => nodes[0].focus(), 100)
    }
  }
})

const onOk = () => {
  emit('ok')
  emitter.emit('APP_ALERT_OK')
}
const onCancel = () => {
  emit('cancel')
  emitter.emit('APP_ALERT_CANCEL')
}

return (_ctx: any,_cache: any) => {
  return (!useNative)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_Transition, { name: "alert" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", {
              class: _normalizeClass(["app-alert", classNames.value])
            }, [
              _hoisted_2,
              _createElementVNode("div", {
                class: "dialog",
                ref_key: "dialog",
                ref: dialog
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _renderSlot(_ctx.$slots, "default", {}, () => [
                    _createElementVNode("div", {
                      class: "message",
                      innerHTML: _ctx.message
                    }, null, 8, _hoisted_4)
                  ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.showCancel)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "javascript:void(0)",
                        onClick: onCancel
                      }, _toDisplayString(_ctx.cancelButtonLabel), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    onClick: onOk
                  }, _toDisplayString(_ctx.buttonLabel), 1)
                ])
              ], 512)
            ], 2), [
              [_vShow, show.value]
            ])
          ]),
          _: 3
        })
      ]))
    : _createCommentVNode("", true)
}
}

})